"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  dataDimension: true
};
exports.default = _default;
//# sourceMappingURL=category.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/d2/model/config/model-defaults/category.js
// module id = 1230
// module chunks = 0